import { HistogramAnnotationsMarkerProps } from '../../components/annotations-histogram/types.js';

/** HistogramChart Annotations.Marker subcomponent props */
export const Marker = (props: HistogramAnnotationsMarkerProps) => null;

Marker['displayName'] = 'HistogramAnnotations.Marker';
